<template>
  <div class="w-full">
    <vs-button
      :disabled="
        !$atividades.permissoes.includes(14) &&
          !$atividades.permissoes.includes(8) &&
          !$atividades.permissoes.includes(1)
      "
      type="relief"
      color="success"
      size="small"
      @click="modalCadastroRota = true"
    >Cadastrar</vs-button>
    <SideBar
      title="Cadastrar Rota"
      @hide="modalCadastroRota = false"
      :active="modalCadastroRota"
      :disabled="!$atividades.permissoes.includes(15) && !$atividades.permissoes.includes(9) && !$atividades.permissoes.includes(3)"
      @success="submitForm()"
      @excluir="excluirPerfil()"
      @status="mudarStatusPerfil()"
      size="small"
    >
      <div slot="body">
        <form>
          <div class="vx-row mb-1">
            <div class="vx-col w-full">
              <vs-input
                class="w-full mb-4 mt-5"
                placeholder="Rota"
                v-model="rota.nome"
                name="nome"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('nome')">
                {{
                $validators.empty
                }}
              </span>
            </div>
            <div class="vx-col w-full">
              <vs-checkbox color="success" v-model="rota.levantamento" class>Levantamento</vs-checkbox>
            </div>
            <div class="vx-col w-full mt-3">
              <label class="text-sm">Técnico responsável</label>
              <el-select
                v-model="rota.id_tecnico_responsavel"
                :popper-append-to-body="false"
                clearable
                filterable
                placeholder="Selecione..."
                class="w-full"
                size="small"
              >
                <el-option
                  v-for="tec in opcoesTecnicos"
                  :key="tec.id"
                  :label="tec.nome"
                  :value="tec.id"
                />
              </el-select>
            </div>
            <div class="vx-col w-full mt-3">
              <label class="text-sm">Tipo de veículo</label>
              <el-select
                v-model="rota.id_tipo_veiculo"
                :popper-append-to-body="false"
                clearable
                filterable
                placeholder="Selecione..."
                class="w-full"
                size="small"
              >
                <el-option
                  v-for="t in tiposVeiculo"
                  :key="t.id"
                  :label="t.nome"
                  :value="t.id"
                />
              </el-select>
            </div>
          </div>
        </form>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import { TIPOS_VEICULO_OPCOES } from "@/constants/tiposVeiculo";

export default {
  props: { tecnicos: { type: Array, default: () => [] } },
  data() {
    return {
      rota: {
        nome: null,
        levantamento: false,
        id_tipo_veiculo: null,
        id_tecnico_responsavel: null
      },
      listaTecnicos: [],
      tiposVeiculo: TIPOS_VEICULO_OPCOES,
      modalCadastroRota: false,
      error: false
    };
  },
  computed: {
    opcoesTecnicos() {
      return this.tecnicos && this.tecnicos.length > 0 ? this.tecnicos : this.listaTecnicos;
    }
  },
  watch: {
    async modalCadastroRota(val) {
      if (val && (!this.tecnicos || this.tecnicos.length === 0)) {
        if (this.listaTecnicos.length === 0) {
          this.$vs.loading();
          try {
            this.listaTecnicos = await this.$http.post('colaboradorAtividade', [10]);
          } catch (e) {
            console.error('Erro ao buscar técnicos:', e);
          } finally {
            this.$vs.loading.close();
          }
        }
      }
    }
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.cadastrarRota();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async cadastrarRota() {
      this.$vs.loading();
      try {
        const res = await this.$http.post(`rota`, this.rota);
        this.rota = {
          nome: null,
          levantamento: false,
          id_tipo_veiculo: null,
          id_tecnico_responsavel: null
        };
        this.$vs.notify(this.$notify.Success);
        this.modalCadastroRota = false;
        // let logData = {
        //   id_colaborador: localStorage.getItem("id"),
        //   funcao: "cadastrar",
        //   setor: "comercial",
        //   ip: window.localStorage.getItem("ip"),
        //   texto: "Cadastro da rota N°" + res.id
        // };
        // await this.$logger(logData);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$emit("update");
        this.$vs.loading.close();
      }
    }
  },
  components: components
};
</script>

<style></style>
